import React from 'react';

import LandingMain from '../../../components/Auth/Landing';
import Layout from '../../../components/Auth/Layout';

const Landing = () => {
  return (
    <Layout bg="landing">
      <LandingMain />
    </Layout>
  );
}

export default Landing;
